import React from 'react';
import { connect } from 'react-redux';
import { array, arrayOf, bool, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import ProfileCard from '../shared/ProfileCard';
import SafePureComponent from '../shared/SafePureComponent';
import ProfileInfo from './ProfileInfo';
import StatsDesc from './StatsDesc';
import Pro from './Pro';

import './style.scss';

const SellerCard = (props) => {
    const {
        description,
        isPro,
        proSubCategories,
        recentDelivery,
        countryCode,
        proficientLanguages,
        memberSince,
        responseTime,
        oneLiner,
        ratingsCount,
        rating,
        achievement,
        hasProfilePhoto,
        profilePhoto,
        sellerName,
        notableClients,
        shouldRenderSellerLanguage
    } = props;

    const showPro = isPro && !_.isEmpty(proSubCategories);

    return (
        <ProfileCard>
            <div className={classNames('seller-card', { 'pro': isPro })}>
                <ProfileInfo oneLiner={oneLiner}
                    ratingsCount={ratingsCount}
                    rating={rating}
                    achievement={achievement}
                    hasProfilePhoto={hasProfilePhoto}
                    profilePhoto={profilePhoto}
                    shouldRenderSellerLanguage={shouldRenderSellerLanguage}
                    countryCode={countryCode}
                    proficientLanguages={proficientLanguages}/>
                {showPro &&
                    <Pro proSubCategories={proSubCategories}/>
                }
                <StatsDesc description={description}
                    recentDelivery={recentDelivery}
                    countryCode={countryCode}
                    memberSince={memberSince}
                    responseTime={responseTime}
                    profilePhoto={profilePhoto}
                    sellerName={sellerName}
                    notableClients={notableClients}/>
            </div>
        </ProfileCard>
    );
};

SellerCard.propTypes = {
    description: string,
    isPro: bool,
    proSubCategories: array,
    recentDelivery: number,
    countryCode: string,
    proficientLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    ),
    memberSince: number,
    responseTime: number,
    oneLiner: string,
    ratingsCount: number,
    rating: number,
    achievement: number,
    hasProfilePhoto: bool,
    profilePhoto: string,
    sellerName: string,
    notableClients: arrayOf(object),
    shouldRenderSellerLanguage: bool
};

const mapStateToProps = ({ ugc }) => {
    const { sellerCard } = getCurrentContent({ ugc });

    return {
        description: sellerCard.description,
        oneLiner: sellerCard.oneLiner
    };
};

const ConnectedSellerCard = connect(mapStateToProps)(SellerCard);

export { SellerCard, ConnectedSellerCard };
export default SafePureComponent(ConnectedSellerCard);
